<div class="profile-container">
  <div class="section-header">
    <h2>Información del Usuario</h2>
  </div>
  <div class="profile-section user-info">
    <div class="info-text">
      <div class="info-grid">
        <div class="info-item">
          <label>Nombre del usuario:</label>
          <input type="text" [value]="userProfile?.name" disabled />
        </div>
        <div class="info-item">
          <label>Apellidos del usuario:</label>
          <input type="text" [value]="userProfile?.lastName" disabled />
        </div>
        <div class="info-item">
          <label>Tipo de documento:</label>
          <input type="text" [value]="userProfile?.tipoDocumento" disabled />
        </div>
        <div class="info-item">
          <label>ID del usuario:</label>
          <input type="text" [value]="userProfile?.id" disabled />
        </div>
        <div class="info-item">
          <label>Ciudad de residencia:</label>
          <input type="text" [value]="userProfile?.city" disabled />
        </div>
        <div class="info-item">
          <label>Departamento de residencia:</label>
          <input type="text" [value]="userProfile?.department" disabled />
        </div>
        <div class="info-item">
          <label>Dirección de residencia:</label>
          <input type="text" [value]="userProfile?.address" disabled />
        </div>
        <div class="info-item">
          <label>Teléfono de contacto:</label>
          <input type="text" [value]="userProfile?.phone" disabled />
        </div>
        <div class="info-item">
          <label>Correo de contacto:</label>
          <input type="text" [value]="userProfile?.email" disabled />
        </div>
        <div class="info-item">
          <label>Cargo que desempeña:</label>
          <input type="text" [value]="userProfile?.role" disabled />
        </div>
      </div>
      <button class="btn" (click)="openModal()">Modificar</button>
    </div>
    <div class="profile-image">
      <img [src]="userProfile?.photo"/>
      <input type="file" id="upload-user-photo" hidden />
    </div>
  </div>
  <div class="section-header">
    <h2>Información de la Entidad</h2>
  </div>
  <div class="profile-section entity-info">
    <div class="info-text">
      <div class="info-grid">
        <div class="info-item">
          <label>Nombre de la entidad:</label>
          <input type="text" [value]="entityProfile?.name" disabled />
        </div>
        <div class="info-item">
          <label>NIT de la entidad:</label>
          <input type="text" [value]="entityProfile?.nit" disabled />
        </div>
        <div class="info-item">
          <label>Correo de la entidad:</label>
          <input type="text" [value]="entityProfile?.email" disabled />
        </div>
        <div class="info-item">
          <label>Teléfono de la entidad:</label>
          <input type="text" [value]="entityProfile?.phone" disabled />
        </div>
        <div class="info-item">
          <label>Dirección de la entidad:</label>
          <input type="text" [value]="entityProfile?.address" disabled />
        </div>
        <div class="info-item">
          <label>Ciudad de la entidad:</label>
          <input type="text" [value]="entityProfile?.city" disabled />
        </div>
      </div>
    </div>
    <div class="company-logo">
      <img [src]="entityProfile?.logo"/>
      <input type="file" id="upload-entity-logo" hidden />
    </div>
  </div>
</div>

<app-modal *ngIf="showModal" [userData]="userProfile" (onSave)="updateProfile($event)" (onClose)="closeModal()"></app-modal>